import {AgencyTier1List} from './agencies';
import {User} from "./user";
import {SubmitNewDocDTO} from "./parties";
import {InputError} from "./security";


export interface ProtestInfo {
  searchChildBnos: string;
  expandRow?: boolean;
  sd_tz: string;
  a_No: string,
  agency_Info_Id: number,
  agency_Name: string,
  agency_tracking_id: string,
  agencyRepInfos: string,
  attorney_Group_Id: number,
  attorney_Name: string,
  b_No: string,
  case_Status: string,
  case_Type: string,
  caseAccessRequestStatus: string,
  caseAccessRequestType: string,
  caseCompletionStatus: CaseCompletionStatus,
  casedocket_email_preferences: string,
  children_Protest_InfoList: ProtestInfo[],
  comments: string,
  company_address1: string,
  company_address2: string,
  company_City: string,
  company_Country: string,
  company_Name: string,
  company_State: string,
  company_Status: string,
  company_Street: string,
  company_Zipcode: string,
  companyNameUserRepresentingTo: string,
  deniedDate: string,
  deniedFileId: string,
  deniedIndicatingDocTypeId: number,
  dmRTC: boolean,
  due_Date: string,
  isUserAdmittedToPO: boolean,
  isUserConsolidated: boolean,
  last_parent_a_no: string,
  listOf_ConsolidatedProtest_Info: ProtestInfo[],
  parent_A_No: string,
  pay_dot_gov_id: string,
  payDotGovTransactionAmt: string,
  po: string,
  primaryAgencyInfoIds: number[],
  public_decision_date: number,
  reasonForDeletion: string,
  representative_address1: string,
  representative_address2: string,
  representative_City: string,
  representative_Country: string,
  representative_Email: string,
  representative_Fax_No: string,
  representative_First_Name: string,
  representative_Last_Name: string,
  representative_Phone_No: string,
  representative_State: string,
  representative_Street: string,
  representative_Zipcode: string,
  role: string,
  roleId: string,
  solicitation_No: string,
  submission_Date: string,
  submissionDateTime: number,
  supplemental_A_Nos: string,
  supplemental_B_Nos: string,
  transaction_Status: string,
  transaction_Amount: string,
  viewOnly: boolean
}

export enum CaseStatus {
  CLOSED = "CLOSED",
  OPEN = "OPEN",
  COMPLETE = "COMPLETE"
}

export interface CaseCompletionStatus {
  isZipCreated: boolean,
  isDmEntered: boolean,
  isDmVerfied: boolean,
  caseCompleted: string,
  dmNumber: string,
  isDeleted: boolean
}


export interface ProtestInfoValidateFormDTO extends ProtestInfo {
  solicitationNumber: string;
  contractorname: string | null;
  agency_tier_1: string;
  agency_tier_2: string | null;
  sizeofbusiness: string | null;
  protective: string | null;
  protectiveorder: string | null;
  lastname: string;
  firstname: string;
  email: string;
  phonenumber: string;
  faxnumber: string | null;
  street: string | null;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  country: string;
  zipcode: string;
  nameoffirm: string | null;
  addmorestatus: string | null;
  typeofdocument: string | null;
  isDocConfidential: string;
  attachAssociatedDoc: string | null;
  attorney_id: string | null;
  filerId: number;
  files: string | null;
  file: string | null;
  submissionDate: string | null;
}

export interface validateProtestInfoResponse {
  protestInfoValidateFormDTO: ProtestInfoValidateFormDTO;
  isSuccess: boolean;
  inputErrors: InputError[];
}

export interface ProtestInfoRegisterFormDTO {
  solicitationNumber: string;
  contractorname: string | null;
  agency_tier_1: string;
  agency_tier_2: string | null;
  sizeofbusiness: string | null;
  comments: string;
  protective: string | null;
  protectiveorder: string | null;
  a_No: string;
  submissionDate: string;
}

export interface UserModel {
  userProfileInfo: User;
  protestInfoRegisterFormDTO: ProtestInfoRegisterFormDTO;
  user_Role: string;
}

export interface CheckUserExistsResponse {
  message: string;
}

export interface UserInfoByEmailResponse {
  user_Info: User;
}

export interface ProtestResponse {
  aNum: string;
  user_Info: User;
  AgencyTier1List: AgencyTier1List[];
  user_Role: string;
}

export interface ProtestForm {
  // Company Information
  Company_Name: string;
  Company_Size: string;

  // Company Address
  Company_Address1: string;
  Company_Address2?: string;
  Company_Zipcode: string;
  Company_City: string;
  Company_State: string;
  Company_Country: string;

  // Protester Representative Information (optional)
  Representative_Email?: string;
  Representative_First_Name?: string;
  Representative_Last_Name?: string;
  Representative_Phone_No?: string;
  Representative_Fax_No?: string;
  Representative_Address1?: string;
  Representative_Address2?: string;
  Representative_Zipcode?: string;
  Representative_City?: string;
  Representative_State?: string;
  Representative_Country?: string;

  // Protest Detail
  solicitaion_Number: string;
  csolicitaion_Number: string;
  agencyTier1Selection: string;
  agencyTier2Dropdown?: string;
  Doc_Confidential: string;
  comments?: string;

  // File Upload Information (optional)
  primaryFileUploadList?: File[];
  primaryEPDSFileList?: File[];
  associateFileUploadList?: File[];
  associateEPDSFileList?: File[];
}

export interface PayGovOnlineResponse {
  payDotGovToken: string;
  a_No: string;
  payDotGovAppId: string;
  payDotGovPaymentUrl: string;
}

export interface TransactionStatus {
  isPaymentSuccess: string;
  payDotGovTrackingId: string;
  transactionStatus: string;
  payDotGovError: PayDotGovError
}

export interface PayDotGovError {
  errorCode: string;
  errorDetail: string;
}

export interface ProtestRequestResponse {
  protestInfo: ProtestInfo;
  role: string;
  user_Role: string;
  aNum: string;
  agencyNameList: string[];
  intervenorCompNameList: string[];
  user_Info: User;
  typeOfProtest: string;
}

export interface FilerType {
  label: string;
  id: number;
}

export interface AccessRequestResponse {
  user_Info: User;
  user_Role: string;
}

export interface ProtestListForIntervenorResponse {
  role: number,
  protestInfoList: ProtestInfo[]
}

export interface AddAgencyRepResponse {
  inputErrors: InputError[];
  submitNewDocDTO: SubmitNewDocDTO
}
